((NavSocialFeed, $) => {  

  const $dom = {};

  const cacheDom = () => {
    $dom.socialFeed = $('.js-nav-social-feed');
  };

  const loadContent = () => {
    var url = 'https://api.instagram.com/v1/users/self/media/recent/?access_token=297046778.d90570a.bd79782e7d8c4424af25b3b72266685e';

    $.ajax({
      type: 'GET',
      url: url,
      dataType: 'jsonp',
      success: function(data) {

        if(data.meta.code === 200 && data.data.length) {
          $dom.socialFeed.each(function(index, el) {
            var innerData = data.data;
            var count = 0;
            $(this).empty();

            for(var i = 0; i < innerData.length; i++) {
              var thisMedia = innerData[i], item;

              var url = thisMedia.images.low_resolution.url;

              if(!thisMedia.images.low_resolution.url.indexOf("null") > -1) {
                item = '<div class="il-photo__img instagram__bg" style="background-image:url('+url+')" data-filter="'+thisMedia.filter+'" /></div>';
                item = '<a href="'+thisMedia.link+'" target="_blank" class="instagram__link">'+item+'</a>';
              }

              if(thisMedia.videos) {
                item = '<div class="instagram__video instagram__bg" style="background-image:url('+url+')" data-filter="'+thisMedia.filter+'" /></div>';
                item = '<a href="'+thisMedia.link+'" target="_blank" class="instagram__link instagram__video-link">'+item+'</a>';
              }

              if(item) {
                item = '<div class="instagram__item instagram-columns">'+item+'</div>';
              }
              if(item !== '') {
                $(this).append(item);
                count++;
              }
              if(count == 3) {
                break;
              }
            }
          });
        }
      },
      error: function(err) {
        console.error(err);

      }
    });
  };

  const init = () => {
    $(window).on('load', () => {
      cacheDom();
      loadContent();
    });
  };

  NavSocialFeed.init = init;

})(window.NavSocialFeed = window.NavSocialFeed || {}, jQuery); 
